export const storageKeys = {
    TOKEN: "TOKEN",
    USER: "USER",
    REFRESH_TOKEN: "REFRESH_TOKEN",
    LANG: "LANG"
}